import { ISoilAnalysis, ISoilAnalysisAlloc } from "../../../omnia"
import { ISoilService, LayerTypeId } from "../../../types"
import { IAnalysisLayerData } from "../map/analysis-layer"
import { IGlobalAllocationBindingModel } from "../types"
import { GlobalAnalysisAlloc } from "./alloc-vm"
import { GlobalAnalysisVM } from "./analysis-vm"
import { GlobalSoilAnalysisAlloc } from "./soilanalysis-alloc-vm"

export class GlobalSoilAnalysisVM extends GlobalAnalysisVM {

    constructor(svc: ISoilService, analysis: ISoilAnalysis) {
        super(analysis);

        if (this.soilAnalysis.Allocations.length) {
            this.allocations = this.soilAnalysis.Allocations
                .map(a => GlobalSoilAnalysisAlloc.createFromAlloc(svc, this, a));
        }
    }

    get soilAnalysis(): ISoilAnalysis {
        return <ISoilAnalysis>this.analysis;
    }

    getAnalysisId(): number {
        return this.soilAnalysis.SoilAnalysisId;
    }

    getDescription(): string {
        return this.soilAnalysis.AnalysisNumber;
    }

    alloc(data: IAnalysisLayerData) {

        this.allocations.push(GlobalSoilAnalysisAlloc.createAlloc(this, data));

    }

    checkAllocationInDatas(allocation: GlobalAnalysisAlloc, datas: IAnalysisLayerData[]): boolean {

        var soilAlloc = <GlobalSoilAnalysisAlloc>allocation;

        if (!allocation.shown) return true;

        if (soilAlloc.zone) {
            return datas.filter(d => d.field.fieldId === soilAlloc.field.fieldId &&
                d.zone === soilAlloc.zone).length > 0;
        }

        return datas.filter(d => !d.zone && d.field.fieldId === soilAlloc.field.fieldId).length > 0;

    }

    checkDataInAllocations(data: IAnalysisLayerData): boolean {

        if (data.zone) {
            return this.allocations.filter(a => (<GlobalSoilAnalysisAlloc>a).field.fieldId === data.field.fieldId &&
                (<GlobalSoilAnalysisAlloc>a).zone &&
                (<GlobalSoilAnalysisAlloc>a).zone === data.zone).length > 0;
        }

        return this.allocations.filter(a => !(<GlobalSoilAnalysisAlloc>a).zone && (<GlobalSoilAnalysisAlloc>a).field.fieldId === data.field.fieldId)
            .length > 0;

    }


    unallocFeature(data: IAnalysisLayerData) {

        if (data.zone) {
            this.allocations = this.allocations.filter(a => !(<GlobalSoilAnalysisAlloc>a).zone || (<GlobalSoilAnalysisAlloc>a).zone !== data.zone);
        } else {
            this.allocations = this.allocations.filter(a => !!(<GlobalSoilAnalysisAlloc>a).zone || (<GlobalSoilAnalysisAlloc>a).field.fieldId !== data.field.fieldId);
        }

    }

    getAllocationModels(): IGlobalAllocationBindingModel[] {

        return this.allocations.map(a => {
            var allocation = <GlobalSoilAnalysisAlloc>a;

            return <IGlobalAllocationBindingModel>{
                AnalysisId: this.soilAnalysis.SoilAnalysisId,
                AllocationId: allocation.allocation ? (<ISoilAnalysisAlloc>allocation.allocation).SoilAnalysisAllocId : null,
                FieldId: allocation.field.fieldId,
                ZoneId: allocation.zone ? allocation.zone.DataLayerZoneId : null,
                SoilTypeLayerId: allocation.layerData && allocation.layerData.layerType === LayerTypeId.SoilType ? allocation.layerData.layer.DataLayerId : null,
                SoilAnalysisLayerId: allocation.layerData && allocation.layerData.layerType === LayerTypeId.SoilAnalysis ?
                    allocation.layerData.layer.DataLayerId : null
            };
        });

    }

}
